const FontStyle = Object.freeze({
  family: Object.freeze({
    primary: 'Inter, sans-serif',
  }),
  size: Object.freeze({
    xs: '10px',
    sm: '12px',
    md: '14px',
    lg: '24px',
    xl: '40px',
  }),
  weight: Object.freeze({
    sm: 300,
    md: 400,
    lg: 500,
    xl: 700,
    xxl: 800,
  }),
});

const Layout = Object.freeze({
  container: Object.freeze({
    primary: Object.freeze({
      margin: '0 auto',
      maxWidth: '1248px',
      padding: '0 24px',
    }),
    md: Object.freeze({
      margin: '0 auto',
      maxWidth: '936px',
      padding: '0 24px',
    }),
    sm: Object.freeze({
      margin: '0 auto',
      maxWidth: '696px',
      padding: '0 24px',
    }),
  }),
  space: Object.freeze({
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '48px',
  }),
  header: Object.freeze({
    height: '64px',
  }),
});

/*
   Usage
   =====
   <div :style="xxxStyle">
     Text which could be extremely long and can be truncated in a single line.
   </div>
   ...
   xxxStyle: {
     ...Truncate.primary,
     width: 'calc(100% - 24px)', // Do not for get add width property.
   }
*/
const Truncate = Object.freeze({
  primary: Object.freeze({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
});

export {
  FontStyle,
  Layout,
  Truncate,
};
